import { render } from "./StorageItem.vue?vue&type=template&id=663465d2&scoped=true"
import script from "./StorageItem.vue?vue&type=script&lang=js"
export * from "./StorageItem.vue?vue&type=script&lang=js"

import "./StorageItem.vue?vue&type=style&index=0&id=663465d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663465d2"]])

export default __exports__